import { getSensitiveDatas, setSensitiveFields } from '@/services/config'
const store = {
  namespaced: true,
  state: {
    // 已设置敏感字段
    sensitiveFields: {
      list: [],
      range: []
    },
    // 全部敏感字段
    allSensitiveFields: [],
    // 默认数据是否正在加载
    setSubmitting: false,
    dataIsReady: false,
    viewSensitive: []
  },
  mutations: {
    setSensitive (state, data) {
      state.sensitiveFields = data
    },
    setDataIsReady (state, b) {
      state.dataIsReady = b
    },
    setSubmitting (state, type) {
      state.setSubmitting = type
    },
    setAllSensitive (state, data) {
      state.allSensitiveFields = data
    },
    setViewSensitive (state, data) {
      state.viewSensitive = data
    }
  },
  actions: {
    // 获取已设置敏感字段
    async fetchSensitiveData ({ commit }) {
      commit('setSubmitting', true)
      commit('setDataIsReady', false)
      const chain = await getSensitiveDatas()
        .onSuccess(raw => {
          commit('setSensitive', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
          commit('setDataIsReady', true)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取所有敏感字段
    async fetchAllSensitiveData ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getSensitiveDatas()
        .params({ edit: 1 })
        .onSuccess(raw => {
          commit('setAllSensitive', raw.list)
          commit('setViewSensitive', raw.range)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 搜索敏感字段
    async searchFields ({ commit }) {
      commit('setSubmitting', true)
      const chain = await getSensitiveDatas()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 设置敏感字段
    async setSensitiveFields ({ commit }) {
      commit('setSubmitting', true)
      const chain = await setSensitiveFields()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: true })
      return chain
    }
  }
}

export default store
